import axiosRequestUtility from "../utilities/AxiosRequestUtility";

class IdVerificationService {
  public GetPlaidToken(): Promise<string> {
    return axiosRequestUtility.Request({
      method: 'GET',
      url: 'GetPlaidToken'
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.log(error);
      alert('Error establishing connection to Plaid. Please try again.')
      return '';
    })
  }

  public GetVerificationDetails(verificationId: string): Promise<boolean | undefined> {
    return axiosRequestUtility.Request({
      method: 'GET',
      url: 'GetVerificationDetails',
      params: 
        {
        'verificationId': verificationId 
        }
    })
    .then(response => {
      return response.data as boolean;
    })
    .catch(error => {
      console.log(error);
      alert('Error establishing connection to Plaid. Please try again.')
      return undefined;
    })
  }
}

const idVerificationService = new IdVerificationService();
export default idVerificationService;